// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--MYWSk";
export var focusVisible = "Button-module--focus-visible--C7wWI";
export var primary = "Button-module--primary--uHAe9";
export var outlinePrimary = "Button-module--outline-primary--P93bp";
export var link = "Button-module--link--zjF44";
export var large = "Button-module--large--CIa21";